<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">

      <!-- Global toggle -->
      <div class="d-flex align-items-center mb-3 alerts-global-row">
        <span class="alerts-global-label">Alerts Enabled</span>
        <b-form-select v-model="model.alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select>
      </div>

      <!-- Late Alerts -->
      <b-card v-if="model.late_alert_enabled" no-body class="alert-section-card mb-2" data-section="isLateAlertVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isLateAlertVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isLateAlertVisible }">&#9654;</span>
          <span class="alert-section-title">Late Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isLateAlertVisible" :visible="!!toggle.isLateAlertVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr>
                <td class="alert-label">Filter Start Yard(s)</td>
                <td>
                  <span class="help-block">Alerts will send for all start locations if no yards are selected</span><br/>
                  <label v-for="option in yard_options" :key="option.value">
                    <input type="checkbox" :value="option.value" v-model="selectedYardOptions">
                    {{ option.text }}&nbsp;&nbsp;&nbsp;
                  </label>
                </td>
              </tr>
              <tr data-field="late_alert_minutes">
                <td class="alert-label">Trigger Minutes After Planned Time</td>
                <td>
                  <b-form-input v-model="model.late_alert_minutes" type="text" :state="numericState('late_alert_minutes')" @input="validateNumeric('late_alert_minutes', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('late_alert_minutes')">{{ numericFeedback('late_alert_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_time_window">
                <td class="alert-label">Alert Time Window</td>
                <td><b-form-input v-model="model.late_alert_time_window" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.late_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_driver_start_time_enabled">
                <td class="alert-label">Trigger Using Driver Start Time</td>
                <td><b-form-select v-model="model.late_alert_driver_start_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_first_departure_time_enabled">
                <td class="alert-label">Trigger Using First Departure Time</td>
                <td><b-form-select v-model="model.late_alert_first_departure_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_hos_login">
                <td class="alert-label">Suppress If HOS Login Detected</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_hos_login" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'TBN'" data-field="late_alert_suppress_if_hos_assigned">
                <td class="alert-label">Suppress If HOS Assignment Detected</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_hos_assigned" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_dvir_created">
                <td class="alert-label">Suppress If Pre Trip DVIR Created</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_dvir_created" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_key_on">
                <td class="alert-label">Suppress If Vehicle Is Turned On</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_key_on" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_speed">
                <td class="alert-label">Suppress If Vehicle Moves</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_speed" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_suppress_if_vehicle_left_yard">
                <td class="alert-label">Suppress If Vehicle Leaves Yard</td>
                <td><b-form-select v-model="model.late_alert_suppress_if_vehicle_left_yard" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_private_hires_only">
                <td class="alert-label">Private Hires Only</td>
                <td><b-form-select v-model="model.late_alert_private_hires_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="late_alert_booking_type_filter">
                <td class="alert-label">Booking Type Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_booking_type_filter" type="text" :state="filterState('late_alert_booking_type_filter')" @input="validateFilter('late_alert_booking_type_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_booking_type_filter')">{{ filterFeedback('late_alert_booking_type_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_booking_id_filter">
                <td class="alert-label">Booking ID Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_booking_id_filter" type="text" :state="filterState('late_alert_booking_id_filter')" @input="validateFilter('late_alert_booking_id_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_booking_id_filter')">{{ filterFeedback('late_alert_booking_id_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_client_id_filter">
                <td class="alert-label">Client ID Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_client_id_filter" type="text" :state="filterState('late_alert_client_id_filter')" @input="validateFilter('late_alert_client_id_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_client_id_filter')">{{ filterFeedback('late_alert_client_id_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_driver_tag_filter">
                <td class="alert-label">Driver Tag Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_driver_tag_filter" type="text" :state="filterState('late_alert_driver_tag_filter')" @input="validateFilter('late_alert_driver_tag_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_driver_tag_filter')">{{ filterFeedback('late_alert_driver_tag_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_vehicle_tag_filter" type="text" :state="filterState('late_alert_vehicle_tag_filter')" @input="validateFilter('late_alert_vehicle_tag_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_vehicle_tag_filter')">{{ filterFeedback('late_alert_vehicle_tag_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_vehicle_filter">
                <td class="alert-label">Vehicle ID Filter</td>
                <td>
                  <b-form-input v-model="model.late_alert_vehicle_filter" type="text" :state="filterState('late_alert_vehicle_filter')" @input="validateFilter('late_alert_vehicle_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('late_alert_vehicle_filter')">{{ filterFeedback('late_alert_vehicle_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_by_booking_type">
                <td class="alert-label">Send By Booking Type</td>
                <td><b-form-input v-model="model.late_alert_by_booking_type" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_by_booking_base">
                <td class="alert-label">Send By Booking Base</td>
                <td>
                  <JsonKeyValueEditor v-model="model.late_alert_by_booking_base" fieldKey="late_alert_by_booking_base" @validation="onJsonValidation" :allow-raw-json="is_admin" keyLabel="Booking Base" valueLabel="Send Rule"/>
                  <b-form-invalid-feedback :state="jsonState('late_alert_by_booking_base')">{{ jsonFeedback('late_alert_by_booking_base') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_by_company_id">
                <td class="alert-label">Send By Company ID</td>
                <td><b-form-input v-model="model.late_alert_by_company_id" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_failed_sms_recipients">
                <td class="alert-label">SMS Failure Recipients</td>
                <td><b-form-input v-model="model.late_alert_failed_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_voice_recipients">
                <td class="alert-label">Voice Recipients</td>
                <td><b-form-input v-model="model.late_alert_voice_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_voice_base_config">
                <td class="alert-label">Voice Base Config</td>
                <td>
                  <JsonKeyValueEditor v-model="model.late_alert_voice_base_config" fieldKey="late_alert_voice_base_config" @validation="onJsonValidation" :allow-raw-json="is_admin" keyLabel="Booking Base" valueLabel="Voice Config"/>
                  <b-form-invalid-feedback :state="jsonState('late_alert_voice_base_config')">{{ jsonFeedback('late_alert_voice_base_config') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="late_alert_voice_message">
                <td class="alert-label">Voice Message Text</td>
                <td><b-form-input v-model="model.late_alert_voice_message" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_voice_time_window">
                <td class="alert-label">Voice Time Window</td>
                <td><b-form-input v-model="model.late_alert_voice_time_window" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_sms">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_email_contract">
                <td class="alert-label">Contract Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_contract" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_email_private">
                <td class="alert-label">Private Hire Email Recipients</td>
                <td><b-form-input v-model="model.late_alert_email_private" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_sms_contract">
                <td class="alert-label">Contract SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms_contract" type="text"></b-form-input></td>
              </tr>
              <tr v-if="tenant_type == 'CM'" data-field="late_alert_sms_private">
                <td class="alert-label">Private Hire SMS Recipients</td>
                <td><b-form-input v-model="model.late_alert_sms_private" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_slack_url">
                <td class="alert-label">Slack Channel URL</td>
                <td><b-form-input v-model="model.late_alert_slack_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_msteams_url">
                <td class="alert-label">MS Teams Channel URL</td>
                <td><b-form-input v-model="model.late_alert_msteams_url" type="text"></b-form-input></td>
              </tr>
              <tr data-field="late_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><b-form-textarea v-model="model.late_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Advanced Late Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isVehicleLateAlertVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehicleLateAlertVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isVehicleLateAlertVisible }">&#9654;</span>
          <span class="alert-section-title">Advanced Late Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.vehicle_late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isVehicleLateAlertVisible" :visible="!!toggle.isVehicleLateAlertVisible">
          <b-card-body>
            <b-button variant="outline-secondary" @click="manage_vehicle_late_events = !manage_vehicle_late_events">Manage Events</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Booking State Alerts (TBN only) -->
      <b-card v-if="tenant_type == 'TBN'" no-body class="alert-section-card mb-2" data-section="isBookingStateAlertVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isBookingStateAlertVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isBookingStateAlertVisible }">&#9654;</span>
          <span class="alert-section-title">Booking State Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.booking_state_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isBookingStateAlertVisible" :visible="!!toggle.isBookingStateAlertVisible">
          <b-card-body>
            <b-button variant="outline-secondary" @click="manage_booking_state_events = !manage_booking_state_events">Manage Events</b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Vehicle Activity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isVehActivityVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehActivityVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isVehActivityVisible }">&#9654;</span>
          <span class="alert-section-title">Vehicle Activity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.eld_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isVehActivityVisible" :visible="!!toggle.isVehActivityVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="eld_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.eld_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.eld_alert_idle_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.eld_alert_idle_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_email_recipients">
                <td class="alert-label">ELD Fault Email Recipients</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_sms_recipients">
                <td class="alert-label">ELD Fault SMS Recipients</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_template">
                <td class="alert-label">Idle Alert SMS Template</td>
                <td><b-form-textarea v-model="model.eld_alert_idle_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
              <tr data-field="eld_alert_idle_alert_sms_geofence_template">
                <td class="alert-label">Idle / Geofence Alert SMS Template</td>
                <td><b-form-textarea v-model="model.eld_alert_idle_alert_sms_geofence_template" style="field-sizing: content"/></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_sms_template">
                <td class="alert-label">ELD Fault SMS Template</td>
                <td><b-form-textarea v-model="model.eld_alert_fault_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
              <tr data-field="eld_alert_fault_alert_mappings">
                <td class="alert-label">ELD Fault Description Mapping</td>
                <td><b-form-input v-model="model.eld_alert_fault_alert_mappings" type="text"></b-form-input></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Vehicle Inactivity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isVehInactiveVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehInactiveVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isVehInactiveVisible }">&#9654;</span>
          <span class="alert-section-title">Vehicle Inactivity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.vehicle_inactivity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isVehInactiveVisible" :visible="!!toggle.isVehInactiveVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="vehicle_inactivity_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.vehicle_inactivity_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_geofence">
                <td class="alert-label">Geofence</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_geofence" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_vehicle_filter">
                <td class="alert-label">Vehicle Filter</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_vehicle_filter" type="text" :state="filterState('vehicle_inactivity_alert_vehicle_filter')" @input="validateFilter('vehicle_inactivity_alert_vehicle_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('vehicle_inactivity_alert_vehicle_filter')">{{ filterFeedback('vehicle_inactivity_alert_vehicle_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_vehicle_tag_filter" type="text" :state="filterState('vehicle_inactivity_alert_vehicle_tag_filter')" @input="validateFilter('vehicle_inactivity_alert_vehicle_tag_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('vehicle_inactivity_alert_vehicle_tag_filter')">{{ filterFeedback('vehicle_inactivity_alert_vehicle_tag_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_active_time_windows">
                <td class="alert-label">Active Time Window</td>
                <td><b-form-input v-model="model.vehicle_inactivity_alert_active_time_windows" type="text"></b-form-input></td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_duration_threshold">
                <td class="alert-label">Duration Threshold</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_duration_threshold" type="text" :state="numericState('vehicle_inactivity_alert_duration_threshold')" @input="validateNumeric('vehicle_inactivity_alert_duration_threshold', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('vehicle_inactivity_alert_duration_threshold')">{{ numericFeedback('vehicle_inactivity_alert_duration_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_speed_threshold">
                <td class="alert-label">Speed Threshold</td>
                <td>
                  <b-form-input v-model="model.vehicle_inactivity_alert_speed_threshold" type="text" :state="numericState('vehicle_inactivity_alert_speed_threshold')" @input="validateNumeric('vehicle_inactivity_alert_speed_threshold', $event, 0, 200)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('vehicle_inactivity_alert_speed_threshold')">{{ numericFeedback('vehicle_inactivity_alert_speed_threshold') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="vehicle_inactivity_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><b-form-textarea v-model="model.vehicle_inactivity_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- HOS Duration Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isHOSDurationVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isHOSDurationVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isHOSDurationVisible }">&#9654;</span>
          <span class="alert-section-title">HOS Duration Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.driver_hos_alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isHOSDurationVisible" :visible="!!toggle.isHOSDurationVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="driver_hos_alerts_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.driver_hos_alerts_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="driver_hos_alerts_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.driver_hos_alerts_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_hos_alerts_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.driver_hos_alerts_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="driver_hos_alerts_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><b-form-textarea v-model="model.driver_hos_alerts_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
              <tr>
                <td class="alert-label"></td>
                <td><b-button variant="outline-secondary" @click="manage_hos_events = !manage_hos_events">Manage Alert Events</b-button></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Unplanned Activity Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isUnplannVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isUnplannVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isUnplannVisible }">&#9654;</span>
          <span class="alert-section-title">Unplanned Activity Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.unplanned_vehicle_activity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isUnplannVisible" :visible="!!toggle.isUnplannVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="unplanned_vehicle_activity_alert_yard_mile_radius">
                <td class="alert-label">Yard Mile Radius</td>
                <td>
                  <b-form-input v-model="model.unplanned_vehicle_activity_alert_yard_mile_radius" type="text" :state="numericState('unplanned_vehicle_activity_alert_yard_mile_radius')" @input="validateNumeric('unplanned_vehicle_activity_alert_yard_mile_radius', $event, 0, 100)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('unplanned_vehicle_activity_alert_yard_mile_radius')">{{ numericFeedback('unplanned_vehicle_activity_alert_yard_mile_radius') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_vehicle_filter">
                <td class="alert-label">Vehicle Filter</td>
                <td>
                  <b-form-input v-model="model.unplanned_vehicle_activity_alert_vehicle_filter" type="text" :state="filterState('unplanned_vehicle_activity_alert_vehicle_filter')" @input="validateFilter('unplanned_vehicle_activity_alert_vehicle_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('unplanned_vehicle_activity_alert_vehicle_filter')">{{ filterFeedback('unplanned_vehicle_activity_alert_vehicle_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.unplanned_vehicle_activity_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.unplanned_vehicle_activity_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="unplanned_vehicle_activity_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><b-form-textarea v-model="model.unplanned_vehicle_activity_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Gateway Disconnect Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isGatewayDisconnectVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isGatewayDisconnectVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isGatewayDisconnectVisible }">&#9654;</span>
          <span class="alert-section-title">Gateway Disconnect Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.gateway_disconnect_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isGatewayDisconnectVisible" :visible="!!toggle.isGatewayDisconnectVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="gateway_disconnect_alert_threshold_minutes">
                <td class="alert-label">Treat as disconnected after (minutes)</td>
                <td>
                  <b-form-input v-model="model.gateway_disconnect_alert_threshold_minutes" type="number" min="1" max="1440" step="1" style="width:100px" placeholder="10" :state="numericState('gateway_disconnect_alert_threshold_minutes')" @keydown="blockNonNumericKeys($event, true)" @input="validateNumeric('gateway_disconnect_alert_threshold_minutes', $event, 1, 1440, true)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('gateway_disconnect_alert_threshold_minutes')">{{ numericFeedback('gateway_disconnect_alert_threshold_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="gateway_disconnect_alert_grace_period_minutes">
                <td class="alert-label">Driver on-duty grace period (minutes)</td>
                <td>
                  <b-form-input v-model="model.gateway_disconnect_alert_grace_period_minutes" type="number" min="0" max="1440" step="1" style="width:100px" placeholder="10" :state="numericState('gateway_disconnect_alert_grace_period_minutes')" @keydown="blockNonNumericKeys($event, true)" @input="validateNumeric('gateway_disconnect_alert_grace_period_minutes', $event, 0, 1440, true)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('gateway_disconnect_alert_grace_period_minutes')">{{ numericFeedback('gateway_disconnect_alert_grace_period_minutes') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="gateway_disconnect_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.gateway_disconnect_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.gateway_disconnect_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.gateway_disconnect_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="gateway_disconnect_alert_sms_template">
                <td class="alert-label">SMS Template</td>
                <td><b-form-textarea v-model="model.gateway_disconnect_alert_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Missing DVIR Alerts -->
      <b-card no-body class="alert-section-card mb-2" data-section="isMissingDVIRVisible">
        <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isMissingDVIRVisible')">
          <span class="alert-chevron mr-2" :class="{ open: toggle.isMissingDVIRVisible }">&#9654;</span>
          <span class="alert-section-title">Missing DVIR Alerts</span>
          <div class="ml-auto" @click.stop>
            <b-form-select v-model="model.missing_dvir_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select>
          </div>
        </b-card-header>
        <b-collapse id="collapse-isMissingDVIRVisible" :visible="!!toggle.isMissingDVIRVisible">
          <b-card-body>
            <table width="100%" class="alert-settings-table" cellpadding="8">
              <tr data-field="missing_dvir_alert_test_mode">
                <td class="alert-label">Test Mode</td>
                <td><b-form-select v-model="model.missing_dvir_alert_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_send_to_driver">
                <td class="alert-label">Send To Driver</td>
                <td><b-form-select v-model="model.missing_dvir_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_enabled">
                <td class="alert-label">Pre Trip Enabled</td>
                <td><b-form-select v-model="model.missing_dvir_alert_pre_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_enabled">
                <td class="alert-label">Post Trip Enabled</td>
                <td><b-form-select v-model="model.missing_dvir_alert_post_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              </tr>
              <tr data-field="missing_dvir_alert_email_recipients">
                <td class="alert-label">Email Recipients</td>
                <td><b-form-input v-model="model.missing_dvir_alert_email_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="missing_dvir_alert_sms_recipients">
                <td class="alert-label">SMS Recipients</td>
                <td><b-form-input v-model="model.missing_dvir_alert_sms_recipients" type="text"></b-form-input></td>
              </tr>
              <tr data-field="missing_dvir_alert_vehicle_tag_filter">
                <td class="alert-label">Vehicle Tag Filter</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_vehicle_tag_filter" type="text" :state="filterState('missing_dvir_alert_vehicle_tag_filter')" @input="validateFilter('missing_dvir_alert_vehicle_tag_filter', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('missing_dvir_alert_vehicle_tag_filter')">{{ filterFeedback('missing_dvir_alert_vehicle_tag_filter') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_skip_drivers">
                <td class="alert-label">Skip Drivers</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_skip_drivers" type="text" :state="filterState('missing_dvir_alert_skip_drivers')" @input="validateFilter('missing_dvir_alert_skip_drivers', $event)"></b-form-input>
                  <b-form-invalid-feedback :state="filterState('missing_dvir_alert_skip_drivers')">{{ filterFeedback('missing_dvir_alert_skip_drivers') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_minutes_to_look_for_dvirs">
                <td class="alert-label">Minutes To Look For DVIRS</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_minutes_to_look_for_dvirs" type="text" :state="numericState('missing_dvir_alert_minutes_to_look_for_dvirs')" @input="validateNumeric('missing_dvir_alert_minutes_to_look_for_dvirs', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_minutes_to_look_for_dvirs')">{{ numericFeedback('missing_dvir_alert_minutes_to_look_for_dvirs') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_minutes_after_leaving">
                <td class="alert-label">Pre Trip Minutes After Leaving</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_pre_trip_minutes_after_leaving" type="text" :state="numericState('missing_dvir_alert_pre_trip_minutes_after_leaving')" @input="validateNumeric('missing_dvir_alert_pre_trip_minutes_after_leaving', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_pre_trip_minutes_after_leaving')">{{ numericFeedback('missing_dvir_alert_pre_trip_minutes_after_leaving') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_pre_trip_sms_template">
                <td class="alert-label">Pre Trip SMS Template</td>
                <td><b-form-textarea v-model="model.missing_dvir_alert_pre_trip_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_minutes_after_finish">
                <td class="alert-label">Post Trip Minutes After Finish</td>
                <td>
                  <b-form-input v-model="model.missing_dvir_alert_post_trip_minutes_after_finish" type="text" :state="numericState('missing_dvir_alert_post_trip_minutes_after_finish')" @input="validateNumeric('missing_dvir_alert_post_trip_minutes_after_finish', $event, 0, 1440)"></b-form-input>
                  <b-form-invalid-feedback :state="numericState('missing_dvir_alert_post_trip_minutes_after_finish')">{{ numericFeedback('missing_dvir_alert_post_trip_minutes_after_finish') }}</b-form-invalid-feedback>
                </td>
              </tr>
              <tr data-field="missing_dvir_alert_post_trip_sms_template">
                <td class="alert-label">Post Trip SMS Template</td>
                <td><b-form-textarea v-model="model.missing_dvir_alert_post_trip_sms_template" style="field-sizing: content; max-width: 800px"/></td>
              </tr>
            </table>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Manage HOS Alert Configurations" size="huge" v-model="manage_hos_events" ok-only id="hosModal" @ok="hosModalOk($event)">
      <b> Alert Hour is the hour the alert should send. Only 4 alert events are allowed.</b><br/><br/>
      <div v-if="loading">
        <b-spinner style="width: 2rem; height: 1rem;" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-table v-if="this.hos_alert_event_settings" :items="this.hos_alert_event_settings" :fields="['eventName','eventType','hours','limit','days','phone','email','update','remove']">
          <template slot="update" slot-scope="row">
            <b-button size=" sm" @click="update_hos_event(row.item.eventName)">update</b-button>
            <br/>
          </template>
          <template slot="remove" slot-scope="row">
            <b-button size=" sm" @click="delete_hos_event(row.item.eventName)">remove</b-button>
          </template>
        </b-table>
        <hr/>
        <div style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isHOSAddEventVisible')">&#43; Add Configuration</div><br/>
        <span :style="toggle.isHOSAddEventVisible ? '' : 'display:none'">
            <div><b>
              Event Name: <b-form-input v-model="add_hos_event_model.eventName" required/>
              Event Type: <b-form-select v-model="add_hos_event_model.eventType" :options="hos_event_options" style="width:200px"></b-form-select><br/>
              Alert Hour: <b-form-input v-model="add_hos_event_model.hours" required :state="numericState('hos_hours')" @input="validateNumeric('hos_hours', $event, 0, 23)"/>
              <b-form-invalid-feedback :state="numericState('hos_hours')">{{ numericFeedback('hos_hours') }}</b-form-invalid-feedback>
              On Duty/Driving Total Limit: <b-form-input v-model="add_hos_event_model.limit" required :state="numericState('hos_limit')" @input="validateNumeric('hos_limit', $event, 0, 168)"/>
              <b-form-invalid-feedback :state="numericState('hos_limit')">{{ numericFeedback('hos_limit') }}</b-form-invalid-feedback>
              Number of Days: <b-form-input v-model="add_hos_event_model.days" required :state="numericState('hos_days')" @input="validateNumeric('hos_days', $event, 1, 30)"/>
              <b-form-invalid-feedback :state="numericState('hos_days')">{{ numericFeedback('hos_days') }}</b-form-invalid-feedback>
              Phone: <b-form-input v-model="add_hos_event_model.phone" />
              Email: <b-form-input v-model="add_hos_event_model.email" />
            </b></div><br/>
            <b-button v-if="!loading" variant="success" size=" sm" @click="add_hos_event()">Save Alert Event</b-button>
          </span>
      </div>
    </b-modal>

    <b-modal title="Manage Booking State Alert Configurations" size="huge" v-model="manage_booking_state_events" ok-only id="booking_state_alert_modal" @ok="bookingStateModalOk($event)">
      <b-table v-if="this.booking_state_alert_settings" :items="this.booking_state_alert_settings" :fields="['eventName','event_types','hrs_before','hrs_after','email_recipients','update','remove']">
        <template slot="event_types" slot-scope="row">
          <span v-for="(item,idx) in row.item.event_types">
            <span v-if="idx < 3">{{item}}<br/></span>
            <span v-else-if="idx == 3">...</span>
          </span>
        </template>
        <template slot="email_recipients" slot-scope="row">
          <span v-if="row.item.email_recipients">
            <span v-for="item in row.item.email_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" @click="update_booking_state_event(row.item.eventName)">update</b-button>
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_booking_state_event(row.item.eventName)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <div style="font-weight: bold; font-size: 18px;" v-on:click="open_add_booking_state_form()">&#43; Add Configuration</div><br/>
      <span :style="toggle.isBookingStateAddEventVisible ? '' : 'display:none'">
          <div><b>
            Event Name: <b-form-input v-model="add_booking_state_alert_model.eventName" required/>
            <br/>
            Event Types: <b-form-checkbox-group v-model="add_booking_state_alert_model.event_types" :options="booking_state_alert_options_computed"></b-form-checkbox-group>
            <small style="color: #888;">Invalid Actuals is a post-trip check and must be configured separately.</small>
            <br/>
            <span v-if="(add_booking_state_alert_model.event_types || []).some(t => t !== 'Invalid Actuals')">
            Hours Before Departure: <b-form-input v-model="add_booking_state_alert_model.hrs_before" :state="numericState('bsa_hrs_before')" @input="validateNumeric('bsa_hrs_before', $event, 0, 168)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('bsa_hrs_before')">{{ numericFeedback('bsa_hrs_before') }}</b-form-invalid-feedback>
            </span>
            <span v-if="(add_booking_state_alert_model.event_types || []).includes('Invalid Actuals')">
            Hours After Last Arrival: <b-form-input v-model="add_booking_state_alert_model.hrs_after" :state="numericState('bsa_hrs_after')" @input="validateNumeric('bsa_hrs_after', $event, 0, 48)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('bsa_hrs_after')">{{ numericFeedback('bsa_hrs_after') }}</b-form-invalid-feedback>
            </span>
            <br/>
            Check Every (hrs): <b-form-select v-model="add_booking_state_alert_model.poll_interval_hrs" :options="[{value:'1',text:'1 hr'},{value:'2',text:'2 hrs'},{value:'3',text:'3 hrs'},{value:'4',text:'4 hrs'},{value:'6',text:'6 hrs'},{value:'8',text:'8 hrs'},{value:'12',text:'12 hrs'},{value:'24',text:'24 hrs'}]" style="width:120px"></b-form-select>
            <br/>
            Email Recipients: <b-form-input v-model="add_booking_state_alert_model.email_recipients" />
          </b></div><br/>
          <div style="color:red; font-weight:bold;" v-if='this.error_msg !=""'>
            <b>{{this.error_msg}}</b><br/>
          </div>
          <b-button v-if="!loading" variant="success" size="sm" @click="add_booking_state_event()">Save</b-button>
      </span>
    </b-modal>

    <b-modal title="Manage Vehicle Late Alert Configurations" size="huge" v-model="manage_vehicle_late_events" ok-only id="vehicle_late_alert_modal" @ok="vehicleLateModalOk($event)">
      <b-table v-if="this.vehicle_late_alert_settings" :items="this.vehicle_late_alert_settings" :fields="['eventName','event_types','minutes_threshold','send_to_driver','sms_recipients','voice_recipients','email_recipients','update','remove']">
        <template slot="event_types" slot-scope="row">
          <span v-for="(item,idx) in row.item.event_types">
            <span v-if="idx < 2">{{item}}<br/></span>
            <span v-else-if="idx == 2">...</span>
          </span>
        </template>
        <template slot="sms_recipients" slot-scope="row">
          <span v-if="row.item.sms_recipients">
            <span v-for="(item,idx) in row.item.sms_recipients.split(',')">
              <span v-if="idx < 2">{{item}}<br/></span>
              <span v-else-if="idx == 2">...</span>
            </span>
          </span>
        </template>
        <template slot="email_recipients" slot-scope="row">
          <span v-if="row.item.email_recipients">
            <span v-for="item in row.item.email_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="voice_recipients" slot-scope="row">
          <span v-if="row.item.voice_recipients">
            <span v-for="item in row.item.voice_recipients.split(',')">{{item.trim()}}<br/></span>
          </span>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" @click="update_vehicle_late_event(row.item.eventName)">update</b-button>
          <br/>
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_vehicle_late_event(row.item.eventName)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <div ref="LateAlertModal" style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isVehicleLateAddEventVisible')">&#43; Add Configuration</div><br/>
      <span :style="toggle.isVehicleLateAddEventVisible ? '' : 'display:none'">
          <div><b>
            Event Name: <b-form-input v-model="add_vehicle_late_alert_model.eventName" required/>
            <br/>
            Events Types:
            <div style="margin-top: 4px; display: flex; flex-wrap: wrap; align-items: flex-start; gap: 4px 0;">
              <template v-for="(group, groupIdx) in vehicle_late_alert_groups">
                <div v-if="groupIdx > 0" style="border-left: 1px solid #ccc; margin: 0 10px; align-self: stretch;"></div>
                <div style="display: flex; flex-direction: row; gap: 0 12px;">
                  <div v-if="group.columns" v-for="col in group.columns" style="display: flex; flex-direction: column;">
                    <b-form-checkbox
                      v-for="item in col"
                      :key="item"
                      v-model="add_vehicle_late_alert_model.event_types"
                      :value="item"
                      :disabled="isEventTypeDisabled(item)"
                    >{{ item }}</b-form-checkbox>
                  </div>
                  <div v-if="group.items" style="display: flex; flex-direction: column;">
                    <b-form-checkbox
                      v-for="item in group.items"
                      :key="item"
                      v-model="add_vehicle_late_alert_model.event_types"
                      :value="item"
                      :disabled="isEventTypeDisabled(item)"
                    >{{ item }}</b-form-checkbox>
                  </div>
                </div>
              </template>
            </div>
            <br/>
            Minutes Threshold: <b-form-input v-model="add_vehicle_late_alert_model.minutes_threshold" :state="numericState('vla_minutes_threshold')" @input="validateNumeric('vla_minutes_threshold', $event, -60, 1440)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_minutes_threshold')">{{ numericFeedback('vla_minutes_threshold') }}</b-form-invalid-feedback>
            Distance Threshold:<b-form-input v-model="add_vehicle_late_alert_model.distance_threshold" :disabled=!isEnabled(add_vehicle_late_alert_model) :state="numericState('vla_distance_threshold')" @input="validateNumeric('vla_distance_threshold', $event, 0, 1000)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_distance_threshold')">{{ numericFeedback('vla_distance_threshold') }}</b-form-invalid-feedback>
            <span v-if="tenant_type == 'TBN'">
            Use Driver Start Time: <b-form-select v-model="add_vehicle_late_alert_model.driver_start" :options="boolean_options"/>
            Use First Departure Time: <b-form-select v-model="add_vehicle_late_alert_model.departure"  :options="boolean_options"/>
            </span>
            Minutes Before Start Time To Look For Data: <b-form-input v-model="add_vehicle_late_alert_model.minutes_before" :state="numericState('vla_minutes_before')" @input="validateNumeric('vla_minutes_before', $event, 0, 1440)"></b-form-input>
            <b-form-invalid-feedback :state="numericState('vla_minutes_before')">{{ numericFeedback('vla_minutes_before') }}</b-form-invalid-feedback>
            Time Window: <b-form-input v-model="add_vehicle_late_alert_model.time_window"></b-form-input>
            SMS Template: <b-form-textarea v-model="add_vehicle_late_alert_model.sms_template" style="field-sizing: content; max-width: 800px" required/>
            Send To Driver: <b-form-select v-model="add_vehicle_late_alert_model.send_to_driver" :options="boolean_options"/>
            SMS Recipients: <b-form-input v-model="add_vehicle_late_alert_model.sms_recipients" />
            Voice Call Recipients: <b-form-input v-model="add_vehicle_late_alert_model.voice_recipients" />
            Voice Message: <b-form-input v-model="add_vehicle_late_alert_model.voice_message" />
            Voice Time Window: <b-form-input v-model="add_vehicle_late_alert_model.voice_time_window" />
            Email Recipients: <b-form-input v-model="add_vehicle_late_alert_model.email_recipients" />

            <span v-if="tenant_type != 'TBN'">
              Slack URL: <b-form-input v-model="add_vehicle_late_alert_model.slack_url" />
              MS Teams URL: <b-form-input v-model="add_vehicle_late_alert_model.msteams_url" />
            </span>

            <div style="margin:5px; color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'showAdvLateAlertFilters')">&#43; Show Filters</div>
            <div v-if="toggle.showAdvLateAlertFilters" style="margin-left:10px; padding: 10px; border: 1px solid black">
              Contracts Enabled: <b-form-select v-model="add_vehicle_late_alert_model.contracts_enabled" :options="boolean_options"/>
              Charters Enabled: <b-form-select v-model="add_vehicle_late_alert_model.private_hires_enabled" :options="boolean_options"/>
              Driver Name Filter: <b-form-input v-model="add_vehicle_late_alert_model.driver_name_filter" :state="filterState('adv_late_driver_name_filter')" @input="validateFilter('adv_late_driver_name_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_driver_name_filter')">{{ filterFeedback('adv_late_driver_name_filter') }}</b-form-invalid-feedback>
              Driver Tag Filter: <b-form-input v-model="add_vehicle_late_alert_model.driver_tag_filter" :state="filterState('adv_late_driver_tag_filter')" @input="validateFilter('adv_late_driver_tag_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_driver_tag_filter')">{{ filterFeedback('adv_late_driver_tag_filter') }}</b-form-invalid-feedback>
              Vehicle Tag Filter: <b-form-input v-model="add_vehicle_late_alert_model.vehicle_tag_filter" :state="filterState('adv_late_vehicle_tag_filter')" @input="validateFilter('adv_late_vehicle_tag_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_vehicle_tag_filter')">{{ filterFeedback('adv_late_vehicle_tag_filter') }}</b-form-invalid-feedback>
              Booking Base Filter: <b-form-input v-model="add_vehicle_late_alert_model.booking_base_filter" :state="filterState('adv_late_booking_base_filter')" @input="validateFilter('adv_late_booking_base_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_booking_base_filter')">{{ filterFeedback('adv_late_booking_base_filter') }}</b-form-invalid-feedback>
              Movement Start Base Filter: <b-form-input v-model="add_vehicle_late_alert_model.movement_start_base_filter" :state="filterState('adv_late_movement_start_base_filter')" @input="validateFilter('adv_late_movement_start_base_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_movement_start_base_filter')">{{ filterFeedback('adv_late_movement_start_base_filter') }}</b-form-invalid-feedback>
              Company ID Filter: <b-form-input v-model="add_vehicle_late_alert_model.company_id_filter" :state="filterState('adv_late_company_id_filter')" @input="validateFilter('adv_late_company_id_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_company_id_filter')">{{ filterFeedback('adv_late_company_id_filter') }}</b-form-invalid-feedback>
              Client ID Filter: <b-form-input v-model="add_vehicle_late_alert_model.client_id_filter" :state="filterState('adv_late_client_id_filter')" @input="validateFilter('adv_late_client_id_filter', $event)" /><b-form-invalid-feedback :state="filterState('adv_late_client_id_filter')">{{ filterFeedback('adv_late_client_id_filter') }}</b-form-invalid-feedback>
            </div>
          </b></div><br/>
          <div style="color:red; font-weight:bold;" v-if='this.error_msg !="" '>
            <b>{{this.error_msg}}</b><br/>
          </div>
          <b-button v-if="!loading" variant="success" size="sm" @click="add_vehicle_late_event()">Save</b-button>
        </span>
    </b-modal>

    <div class="tc-sticky-save">
      <transition name="tc-save-slide">
      <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
        <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
        <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
        &nbsp;&nbsp;
        <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
      </div>
      </transition>
    </div>
  </div>

</template>
<script>
import {add_hos_event, add_vehicle_late_alert_event, delete_hos_event, delete_vehicle_late_alert_event, add_booking_state_alert_event, delete_booking_state_alert_event, get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import JsonKeyValueEditor from './JsonKeyValueEditor.vue'

export default {
  name: 'tenant_config',
  mixins: [numericValidationMixin, filterValidationMixin, jsonValidationMixin, dirtyTrackingMixin],
  components: {
    JsonKeyValueEditor,
  },

  data() {
    return {
      add_hos_event_model: {},
      manage_hos_events: false,
      hos_alert_event_settings: [],
      add_vehicle_late_alert_model: {},
      manage_vehicle_late_events: false,
      vehicle_late_alert_settings: [],
      add_booking_state_alert_model: {},
      manage_booking_state_events: false,
      booking_state_alert_settings: [],
      booking_state_alert_options: [],
      error_msg: "",
      model: {},
      tenant_json: {},
      toggle: {
        isLateAlertVisible: false,
        isVehicleLateAlertVisible: false,
        isBookingStateAlertVisible: false,
        isVehActivityVisible: false,
        isVehInactiveVisible: false,
        isHOSDurationVisible: false,
        isUnplannVisible: false,
        isGatewayDisconnectVisible: false,
        isMissingDVIRVisible: false,
        isHOSAddEventVisible: false,
        isBookingStateAddEventVisible: false,
        isVehicleLateAddEventVisible: false,
        showAdvLateAlertFilters: false,
      },
      summary: {},
      loading: true,
      selectedYardOptions: [],
      selectedEventOptions: [],
      yard_options: [],
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      hos_event_options: [
        { text: 'Total', value: 'total' },
        { text: 'Driving', value: 'driving' },
        { text: 'On Duty', value: 'onduty' },
      ],
      vehicle_late_alert_groups: [],
      fieldPrefixSectionMap: [
        ['late_alert_', 'isLateAlertVisible'],
        ['vehicle_late_alert_', 'isVehicleLateAlertVisible'],
        ['booking_state_alert_', 'isBookingStateAlertVisible'],
        ['eld_alert_', 'isVehActivityVisible'],
        ['vehicle_inactivity_alert_', 'isVehInactiveVisible'],
        ['driver_hos_alerts_', 'isHOSDurationVisible'],
        ['unplanned_vehicle_activity_alert_', 'isUnplannVisible'],
        ['gateway_disconnect_alert_', 'isGatewayDisconnectVisible'],
        ['missing_dvir_alert_', 'isMissingDVIRVisible'],
      ],
      jsonFieldToggleMap: {
        late_alert_by_booking_base: 'isLateAlertVisible',
        late_alert_voice_base_config: 'isLateAlertVisible',
      },
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      this.error_msg = ""
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        this.tenant_json = data.summary.tenant
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

        this.add_vehicle_late_alert_model = {'event_types': []}
        if (this.tenant_type == 'CM') {
          this.vehicle_late_alert_groups = [
            { columns: [['No Driver HOS Login', 'No Driver DVIR', 'Vehicle Not Started'], ['Vehicle Not Moved', 'Vehicle Not Left']] },
            { items: ['Vehicle Not Near Spot'] },
            { items: ['Vehicle Est Late To Pickup'] },
            { items: ['Vehicle Not Ready'] },
          ]
        }
        else if (this.tenant_type == 'FASTTRAK') {
          this.vehicle_late_alert_groups = [
            { items: ['Vehicle Not Left'] },
            { items: ['Vehicle Est Late To Pickup'] },
            { items: ['Vehicle Not Ready'] },
          ]
        } else {
          this.vehicle_late_alert_groups = [
            { columns: [['No Driver HOS Login', 'No TBN Driver Login', 'No Driver DVIR'], ['Vehicle Not Started', 'Vehicle Not Moved', 'Vehicle Not Left']] },
            { items: ['Vehicle Not Ready'] },
          ]
        }

        try {
          if (this.model.driver_hos_alerts_settings != "" && this.model.driver_hos_alerts_settings != null) {
            this.hos_alert_event_settings = JSON.parse(this.model.driver_hos_alerts_settings);
          } else {
            this.hos_alert_event_settings = []
          }
        } catch(e) {
          console.log('exception converting hos alert settings to json:' + e)
        }

        try {
          if (this.model.vehicle_late_alert_settings != null && this.model.vehicle_late_alert_settings != "") {
            this.vehicle_late_alert_settings = JSON.parse(this.model.vehicle_late_alert_settings);
          } else {
            this.vehicle_late_alert_settings = []
          }
        } catch(e) {
          console.log('exception converting vehicle late alert settings to json:', e)
        }

        this.add_booking_state_alert_model = { event_types: [] }
        this.booking_state_alert_options = [
          { value: 'Missing Driver',    text: 'Missing Driver' },
          { value: 'Missing Vehicle',   text: 'Missing Vehicle' },
          { value: 'Invalid Times',     text: 'Invalid Times' },
          { value: 'Invalid Locations', text: 'Invalid Locations' },
          { value: 'Invalid Actuals',   text: 'Invalid Actuals' },
        ]

        try {
          if (this.model.booking_state_alert_settings != null && this.model.booking_state_alert_settings != "") {
            this.booking_state_alert_settings = JSON.parse(this.model.booking_state_alert_settings);
          } else {
            this.booking_state_alert_settings = []
          }
        } catch(e) {
          console.log('exception converting booking state alert settings to json:', e)
        }

        try {
          if (this.model.late_alert_yards != null && this.model.late_alert_yards != "") {
            this.model.late_alert_yards = JSON.parse(this.model.late_alert_yards)
            this.selectedYardOptions = this.model.late_alert_yards.split(",")
          } else {
            this.selectedYardOptions = []
          }
          if (this.model.vehicle_yards != null && this.model.vehicle_yards != "") {
            this.model.vehicle_yards = JSON.parse(this.model.vehicle_yards);
            let options = []
            for (const item of this.model.vehicle_yards) {
              let yard = { text: item.yard_name, value: item.yard_name }
              options.push(yard)
            }
            this.yard_options = options
          }
        } catch(e) {
          console.log('error setting up vehicle yards for late alerts',e)
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this._prev_gateway_disconnect_enabled = this.model.gateway_disconnect_alert_enabled
      this.loading = false
      this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const was_gw_disconnect_off = this._prev_gateway_disconnect_enabled !== 'True'
        this.setup_yards_to_save()

        for (const objkey of this.objectKeyList) {
          try {
            if (this.model[objkey] && this.model[objkey].trim && this.model[objkey].trim() !== '') {
              let setting = JSON.parse(this.model[objkey])
              this.model[objkey] = setting
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            await this.load_data()
            return
          }
        }
        await update_tenant_config_settings(this.user.tenant, this.model)
        await this._resetDirtyTracking()
        this.load_data(true)

        if (was_gw_disconnect_off && this.model.gateway_disconnect_alert_enabled === 'True' && (!this.model.vehicle_yards || (Array.isArray(this.model.vehicle_yards) && this.model.vehicle_yards.length === 0))) {
          this.$emit('showAlert', 'Configuration Saved — Warning: Gateway disconnect alerts are enabled but no vehicle yards are configured. Alerts will not trigger until at least one yard is added on the General Settings page.', 'warning', 15000)
        } else {
          this.$emit('showAlert', 'Configuration Saved', 'success',5000)
        }
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    setup_yards_to_save() {
      if (this.selectedYardOptions != null && this.selectedYardOptions != "") {
        this.model.late_alert_yards = this.selectedYardOptions.join()
      } else {
        this.model.late_alert_yards = ""
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item, field, setting) {
      if (item[field] !== setting) {
        this.$set(item, field, setting)
      }
    },
    toggle_div(item, field) {
      this.$set(item, field, !item[field])
    },
    eval_event() {
      const types = this.add_vehicle_late_alert_model.event_types
      this.add_vehicle_late_alert_model.event_types = types
    },
    isEnabled(event) {
      if (event.event_types) {
        return (event.event_types.includes('Vehicle Not Near Spot'))
      } else {
        return false
      }
    },
    isEventTypeDisabled(eventType) {
      const selected = this.add_vehicle_late_alert_model.event_types || []
      if (selected.length === 0) return false
      const flatItems = group => group.columns ? group.columns.flat() : group.items
      const activeGroup = this.vehicle_late_alert_groups.find(group =>
        flatItems(group).some(item => selected.includes(item))
      )
      if (!activeGroup) return false
      return !flatItems(activeGroup).includes(eventType)
    },
    async hosModalOk($event) {
      this.add_hos_event_model = {}
      this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', false)
    },
    async add_hos_event() {
      this.loading=true
      if (this.hos_alert_event_settings.length == 4) {
        const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == this.add_hos_event_model.eventName)[0]
        if (alert_event_item) {
          this.save_hos_event()
        } else {
          this.cancel_save_hos_event()
        }
      } else {
        this.save_hos_event()
      }
    },
    async save_hos_event() {
      await add_hos_event(this.user.tenant, this.add_hos_event_model)
      this.add_hos_event_model = {}
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      await this.load_data()
    },
    async cancel_save_hos_event() {
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      this.manage_hos_events = false
      this.add_hos_event_model = {}
      await this.load_data()
    },
    async update_hos_event(event_name) {
      const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', true)
        this.add_hos_event_model = alert_event_item
      }
    },
    async delete_hos_event(event_name) {
      this.loading=true
      await delete_hos_event(this.user.tenant, event_name)
      await this.load_data()
    },

    async vehicleLateModalOk($event) {
      this.error_msg = ""
      this.add_vehicle_late_alert_model = {}
      this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', false)
    },
    async add_vehicle_late_event() {
      this.error_msg = ""
      const drv_st = this.add_vehicle_late_alert_model.driver_start != null ? this.add_vehicle_late_alert_model.driver_start.toLowerCase() : null;
      const dep = this.add_vehicle_late_alert_model.departure != null ? this.add_vehicle_late_alert_model.departure.toLowerCase() : null

      if (!this.add_vehicle_late_alert_model.eventName || (this.add_vehicle_late_alert_model.event_types===null || this.add_vehicle_late_alert_model.event_types.length===0) 
        || !this.add_vehicle_late_alert_model.sms_template || 
        (this.tenant_type == 'TBN' 
        && ( ((!drv_st || drv_st===null) && (!dep || dep===null))
        || ( (drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) 
        || (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase()) ) ))) {
        if (!this.add_vehicle_late_alert_model.eventName) {
          this.error_msg = "Please add an Event Name"
        } 
        if (this.add_vehicle_late_alert_model.event_types === null || this.add_vehicle_late_alert_model.event_types.length===0) {
          this.error_msg = "Please add one or more Event Types"
        } 
        if (!this.add_vehicle_late_alert_model.sms_template) {
          this.error_msg = "Please add a template"
        }
        if (this.tenant_type == 'TBN') {
          if (((!drv_st || drv_st===null)) && ((!dep || dep===null))) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          } else if ((drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) ||
            (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase())) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          }
        }
        this.loading = false
      } else {
        this.loading=true
        this.error_msg = ""
        this.save_vehicle_late_event()
      }
    },
    async save_vehicle_late_event() {
      await add_vehicle_late_alert_event(this.user.tenant, this.add_vehicle_late_alert_model)
      this.add_vehicle_late_alert_model = {}
      this.toggle_div(this.toggle, 'isVehicleLateAddEventVisible')
      await this.load_data()
    },
    async update_vehicle_late_event(event_name) {
      const alert_event_item = this.vehicle_late_alert_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', true)
        this.add_vehicle_late_alert_model = alert_event_item
      }
    },
    async delete_vehicle_late_event(event_name) {
      this.loading=true
      await delete_vehicle_late_alert_event(this.user.tenant, event_name)
      await this.load_data()
    },

    async bookingStateModalOk($event) {
      this.error_msg = ""
      this.add_booking_state_alert_model = { event_types: [] }
      this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', false)
    },
    open_add_booking_state_form() {
      if (!this.toggle.isBookingStateAddEventVisible) {
        this.add_booking_state_alert_model = { event_types: [] }
      }
      this.toggle_div(this.toggle, 'isBookingStateAddEventVisible')
    },
    async add_booking_state_event() {
      this.error_msg = ""
      if (!this.add_booking_state_alert_model.eventName) {
        this.error_msg = "Please add an Event Name"
        return
      }
      if (!this.add_booking_state_alert_model.event_types || this.add_booking_state_alert_model.event_types.length === 0) {
        this.error_msg = "Please select at least one Event Type"
        return
      }
      if (!this.add_booking_state_alert_model.email_recipients) {
        this.error_msg = "Please add Email Recipients"
        return
      }
      this.loading = true
      this.error_msg = ""
      await add_booking_state_alert_event(this.user.tenant, this.add_booking_state_alert_model)
      this.add_booking_state_alert_model = { event_types: [] }
      this.toggle_div(this.toggle, 'isBookingStateAddEventVisible')
      await this.load_data()
    },
    async update_booking_state_event(event_name) {
      const alert_event_item = this.booking_state_alert_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', true)
        const item = { ...alert_event_item }
        if (item.event_types && !Array.isArray(item.event_types)) {
          item.event_types = [item.event_types]
        } else if (!item.event_types) {
          item.event_types = item.event_type ? [item.event_type] : []
        }
        this.add_booking_state_alert_model = item
      }
    },
    async delete_booking_state_event(event_name) {
      this.loading = true
      if (this.add_booking_state_alert_model.eventName === event_name) {
        this.add_booking_state_alert_model = { event_types: [] }
        this.update_toggle_div(this.toggle, 'isBookingStateAddEventVisible', false)
      }
      await delete_booking_state_alert_event(this.user.tenant, event_name)
      await this.load_data()
    },

    isPlainObject(value,key) {
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
    
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    booking_state_alert_options_computed() {
      const raw = this.add_booking_state_alert_model.event_types || []
      const selected = Array.isArray(raw) ? raw : [raw]
      const actualsSelected = selected.includes('Invalid Actuals')
      const pretripsSelected = selected.some(t => t !== 'Invalid Actuals')
      return this.booking_state_alert_options.map(opt => ({
        ...opt,
        disabled: opt.value === 'Invalid Actuals' ? pretripsSelected : actualsSelected
      }))
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";

.alerts-global-row {
  padding: 10px 0 10px 12px;
  font-size: 18px;
  font-weight: bold;
}
.alerts-global-label {
  min-width: 220px;
}
.alert-section-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.alert-section-header {
  cursor: pointer;
  user-select: none;
  background-color: #f8f9fa;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #dee2e6;
}
.alert-section-header:hover {
  background-color: #e9ecef;
}
.alert-section-header--static {
  cursor: default;
  user-select: auto;
}
.alert-section-header--static:hover {
  background-color: #f8f9fa;
}
.alert-section-title {
  color: steelblue;
  font-size: 17px;
}
.alert-chevron {
  display: inline-block;
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}
.alert-chevron.open {
  transform: rotate(90deg);
}
.alert-settings-table td {
  vertical-align: middle;
  padding: 6px 10px;
}
.alert-settings-table td.alert-label {
  text-align: right;
  width: 340px;
  font-weight: 500;
  color: #444;
  white-space: nowrap;
}
.alert-settings-table td:not(.alert-label) {
  text-align: left;
}
</style>
